import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import SelectInstitution from './SelectInstitution';
import { getInstitutions } from "../../../../network/ApiAxios";
import {titleCase} from '../../../../utils/views/pages/Dynamics'
import  secureLocalStorage  from  "react-secure-storage";

const ManagementInformation = (props) => {
    const device = props.device
    const formDisabled = props.formDisabled
    const setDevice = props.setDevice
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const [showSelectInst, setShowSelectInst] = useState(false)
    const [selectOptions, setSelectOptions] = useState([])
    const validations = props.validations
    const user = JSON.parse(secureLocalStorage.getItem("user"));

    useEffect(() => {
        const runAsync = async () => {
            console.log(user)
            let params = { 
                filter: {account: user.account }
            }

            const response = await getInstitutions(params);
            const { data } = response;

            if (data.success && data.institutions.length>0) {
                setSelectOptions(data.institutions)
                setShowSelectInst(true)
            }
        }

        runAsync();

    }, [showSelectInst])

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        device[e.target.name] = e.target.value
        setDevice(device)

    }

    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-detail"
                            >
                                Details
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={device?.detail}
                                id="input-detail"
                                name="detail"
                                placeholder="Device Details"
                                type="textarea"
                                rows="5"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={false}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {function () {
                    if (!showSelectInst)
                        return;

                    return (
                        <Row>
                            <Col lg="6">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-institution"
                                    >
                                        Institution
                                    </label>

                                    <SelectInstitution
                                        institution={device?.institution}
                                        formDisabled={formDisabled}
                                        setDevice={setDevice}
                                        selectOptions={selectOptions}
                                        device={device} />

                                </FormGroup>
                            </Col>
                        </Row>

                    )

                }()

                }
            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ManagementInformation;